import { Modal, Input, Spin, Form, Checkbox, Button } from "antd";
import { theme } from "../../../theme";
import { useTranslation } from "react-i18next";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomModalFooter from "../../../Containers/CustomModalFooter";
import CustomForm from "../../../CustomComponents/CustomForm";
import { AddUpdateCompanyUserModalFormProps } from "./AddUpdateCompanyUserModalForm.types";
import { useAddUpdateCompanyUserFormController } from "./AddUpdateCompanyUserModalForm.controller";
import CustomEditor from "../../../CustomComponents/CustomEditor";

export const AddUpdateCompanyUserModalForm = (
	props: AddUpdateCompanyUserModalFormProps
) => {
	const { t } = useTranslation();
	const { state, actions, computed } =
		useAddUpdateCompanyUserFormController(props);
	const isEditMode = props.type === "edit";
	const shouldShowMentorFields = isEditMode && computed.isMentor;

	return (
		<>
			{props.children ? (
				<span
					onClick={actions.handleShow}
					style={{
						cursor: "pointer",
						display: "inline-flex",
						alignItems: "center",
						width: "100%",
					}}
				>
					{props.children}
				</span>
			) : (
				<Button
					type="primary"
					onClick={actions.handleShow}
					title={t("account.addNewMember")}
				>
					{t("account.addUser")}
				</Button>
			)}

			<Modal
				open={state.isModalVisible}
				onOk={() => state.form.submit()}
				onCancel={actions.handleClose}
				title={
					props.type === "add" ? t("account.addUser") : t("account.editUser")
				}
				width={window.innerWidth > 1215 ? "30%" : "80%"}
				footer={
					<CustomModalFooter
						handleClose={actions.handleClose}
						spinning={state.spinning}
						handleSave={() => state.form.submit()}
						confirmButtonName={t("account.confirm")}
					/>
				}
			>
				<Spin spinning={state.spinning}>
					<Form.Provider
						onFormFinish={
							props.type === "add" ? actions.handleAdd : actions.handleUpdate
						}
					>
						<CustomForm layout={theme.layout} form={state.form}>
							<Form.Item
								name="name"
								label={`${t("account.name")}:`}
								rules={[computed.yupSync]}
								initialValue={computed.defaultValues.name}
								required
								style={{ width: "90%" }}
							>
								<Input placeholder={t("account.name")} />
							</Form.Item>

							<Form.Item
								name="email"
								label={`${t("account.email")}:`}
								rules={[computed.yupSync]}
								initialValue={computed.defaultValues.email}
								required
								style={{ width: "90%" }}
							>
								<Input placeholder={t("account.email")} />
							</Form.Item>

							<Form.Item
								name="phone"
								label={`${t("account.phone")}:`}
								rules={[computed.yupSync]}
								initialValue={computed.defaultValues.phone}
								style={{ width: "90%" }}
							>
								<Input placeholder={t("account.phone")} />
							</Form.Item>

							<Form.Item
								name="function"
								label={`${t("account.function")}:`}
								rules={[computed.yupSync]}
								initialValue={computed.defaultValues.function}
								required
								style={{ width: "90%" }}
							>
								<Input placeholder={t("account.function")} />
							</Form.Item>

							<Form.Item
								name="department"
								label={`${t("account.department")}:`}
								initialValue={computed.defaultValues.department}
								style={{ width: "90%" }}
							>
								<Input placeholder={t("account.department")} />
							</Form.Item>
							{shouldShowMentorFields && (
								<>
									<Form.Item
										name="cnp"
										label={`${t("account.cnp")}:`}
										rules={[computed.yupSync]}
										required
										style={{ width: "90%" }}
									>
										<Input placeholder={t("account.cnp")} />
									</Form.Item>

									<Form.Item
										name="mentorDescription"
										label={`${t("account.mentorDescription")}:`}
										rules={[
											{
												whitespace: true,
											},
										]}
										required
										style={{ width: "90%" }}
									>
										<CustomEditor
											onEditorChange={(content: string) => {
												state.form.setFieldsValue({
													mentorDescription: content,
												});
											}}
										/>
									</Form.Item>
								</>
							)}
							{computed.isCompany && computed.isContact !== true && (
								<Form.Item name="isContact" valuePropName="checked">
									<Checkbox>{`${t("profile.contact")}`}</Checkbox>
								</Form.Item>
							)}
						</CustomForm>
					</Form.Provider>
				</Spin>
			</Modal>
		</>
	);
};
